import { Avatar } from "@material-ui/core";
import React from "react";
import {
  DecryptGrantType,
} from "./../../modules/ml-playlist/mylist/Columns";
import clsx from "clsx";

const getSharedUsers = (classes, data, allUsers) => {

  if (data && data.length) {
    return (
      data && data.map((v) => {
        // var orgUser = allUsers?.find((r) => r.userId === v.uid);
        var orgUser = allUsers?.find((r) => r.email === v.email);
        return (orgUser ? (
          <>
            <div className={classes.sharedUserList}>
              <Avatar
                alt={orgUser?.name}
                src={orgUser?.imageUrl}
                className={classes.smallAvatar}
              ></Avatar>
              <div className={clsx(classes.sharedUserListSinglePreview, orgUser?.isExternal && !orgUser?.hasPermission ? classes.extUser : null)}>
                <div title={orgUser?.name + " " + (orgUser?.bbcCompany || "") + " " + (orgUser?.bbcDepartment || "")} className={classes.sharedUserListName}>{orgUser?.name + " " + (orgUser?.bbcCompany || "") + " " + (orgUser?.bbcDepartment || "")}</div>
                <div title={orgUser?.email} className={classes.sharedUserListEmail}>{orgUser?.email}</div>
                {/* {orgUser?.isExternal &&
                  <div title={orgUser?.orgName} className={clsx(classes.sharedUserListEmail, classes.sharedOrg)}>
                    {orgUser?.orgName}
                  </div>} */}
              </div>
              <div title={DecryptGrantType(v.grant)} className={classes.sharedUserPermission}>
                {DecryptGrantType(v.grant)}
              </div>
            </div>
          </>
        ) : ((v.sMUserName && v.email)?(
            <>
              <div className={classes.sharedUserList}>
                <div className={clsx(classes.sharedUserListSinglePreview, orgUser?.isExternal && !orgUser?.hasPermission ? classes.extUser : null)}>
                  <div title={v.sMUserName} className={classes.sharedUserListName}>{v?.sMUserName}</div>
                  <div title={v.email} className={classes.sharedUserListEmail}>{v.email}</div>
                </div>
              </div>
            </>
        ):null)
        )
      })
    );
  }
  else {
    return <div className={classes.underConstructionMessage} >Not Shared</div>
  }
};

export default ({ label, data, classes, allUsers }) => {
  return (
    <div className={classes.sharePlaylistUsers}>
      <div title={label} className={classes.sharePlaylistUsersLabel}>{label}</div>
      <div className={classes.sharedUserListPreview}>
        {getSharedUsers(classes, data, allUsers)}
      </div>
    </div>
  );
};
